import { render, staticRenderFns } from "./o-health-x1-sq.vue?vue&type=template&id=76ad93da&scoped=true"
import script from "./o-health-x1-sq.vue?vue&type=script&lang=js"
export * from "./o-health-x1-sq.vue?vue&type=script&lang=js"
import style0 from "./o-health-x1-sq.vue?vue&type=style&index=0&id=76ad93da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ad93da",
  null
  
)

export default component.exports